import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7431cf13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "order-mgmt-content-div" }
const _hoisted_3 = { class: "order-mgmt-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-mgmt-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "订单管理")
], -1))
const _hoisted_5 = { class: "filter-bar" }
const _hoisted_6 = { class: "order-info-cell" }
const _hoisted_7 = { class: "order-id-row" }
const _hoisted_8 = { class: "goods-name-row" }
const _hoisted_9 = { class: "amount-row" }
const _hoisted_10 = { class: "auth-info-cell" }
const _hoisted_11 = { class: "auth-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "邮箱", -1))
const _hoisted_13 = { class: "auth-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "授权", -1))
const _hoisted_15 = { class: "auth-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-label" }, "结果", -1))
const _hoisted_17 = { class: "pagination" }

import { ref, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderManageView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const orderList = ref<any[]>([])
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(20)
const total = ref(0)
const filterStatus = ref<number | ''>('')
const filterOrderId = ref('')

// 详情弹窗
const detailDialogVisible = ref(false)
const currentOrder = ref<any>({})

// 修改弹窗
const editDialogVisible = ref(false)
const editForm = ref({
    order_id: '',
    auth_value: '',
    email: '',
})
const submitting = ref(false)

const statusText = (status: number) => {
    const map: Record<number, string> = { 0: '待支付', 1: '已完成', 2: '已取消' }
    return map[status] || '未知'
}

const statusTagType = (status: number) => {
    const map: Record<number, string> = { 0: 'warning', 1: 'success', 2: 'info' }
    return map[status] || 'info'
}

const getOrderList = async () => {
    loading.value = true
    try {
        const params: any = {
            page: currentPage.value,
            pageSize: pageSize.value,
        }
        if (filterStatus.value !== '') {
            params.status = filterStatus.value
        }
        if (filterOrderId.value) {
            params.order_id = filterOrderId.value
        }
        const res = await axios.post(baseURL + '/api/shop/tenant/order/list', params, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            orderList.value = data.list || []
            total.value = data.total || 0
        } else {
            ElMessage.error(res.data.msg || '获取订单列表失败')
        }
    } catch (e: any) {
        ElMessage.error('获取订单列表失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const handleFilter = () => {
    currentPage.value = 1
    getOrderList()
}

const resetFilter = () => {
    filterStatus.value = ''
    filterOrderId.value = ''
    currentPage.value = 1
    getOrderList()
}

const openDetailDialog = (row: any) => {
    currentOrder.value = { ...row }
    detailDialogVisible.value = true
}

const openEditDialog = (row: any) => {
    editForm.value = {
        order_id: row.order_id,
        auth_value: row.auth_value || '',
        email: row.email || '',
    }
    editDialogVisible.value = true
}

const submitEdit = async () => {
    submitting.value = true
    try {
        const payload: any = { order_id: editForm.value.order_id }
        if (editForm.value.auth_value) payload.auth_value = editForm.value.auth_value
        if (editForm.value.email) payload.email = editForm.value.email
        const res = await axios.post(baseURL + '/api/shop/tenant/order/update', payload, { headers })
        if (res.data.code === 0) {
            ElMessage.success('修改成功')
            editDialogVisible.value = false
            getOrderList()
        } else {
            ElMessage.error(res.data.msg || '修改失败')
        }
    } catch (e: any) {
        ElMessage.error('修改失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const markPaid = (row: any) => {
    ElMessageBox.confirm(
        `确认将订单「${row.order_id}」标记为已支付吗？\n标记后系统将执行扣款、授权、反利等逻辑，此操作不可撤销。`,
        '确认标记已支付',
        {
            confirmButtonText: '确认标记',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        try {
            const res = await axios.post(baseURL + '/api/shop/tenant/order/markPaid', { order_id: row.order_id }, { headers })
            if (res.data.code === 0) {
                ElMessage.success('订单已标记为已支付')
                getOrderList()
            } else {
                ElMessage.error(res.data.msg || '操作失败')
            }
        } catch (e: any) {
            ElMessage.error('操作失败：' + e.message)
        }
    }).catch(() => { /* 取消 */ })
}

onMounted(() => {
    getOrderList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"fit-content"} }, {
          default: _withCtx(() => [
            _createVNode(UserHead)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(UserHeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { style: {"padding-top":"0","height":"100vh","overflow":"auto","padding-left":"0","background-color":"rgb(242, 242, 242) !important"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_select, {
                        modelValue: filterStatus.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterStatus).value = $event)),
                        placeholder: "订单状态",
                        clearable: "",
                        style: {"width":"140px"},
                        onChange: handleFilter
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: 0,
                            label: "待支付"
                          }),
                          _createVNode(_component_el_option, {
                            value: 1,
                            label: "已完成"
                          }),
                          _createVNode(_component_el_option, {
                            value: 2,
                            label: "已取消"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        modelValue: filterOrderId.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterOrderId).value = $event)),
                        placeholder: "搜索订单号",
                        clearable: "",
                        style: {"width":"220px"},
                        onClear: handleFilter,
                        onKeyup: _withKeys(handleFilter, ["enter"])
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: handleFilter
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, { onClick: resetFilter }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      })
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      data: orderList.value,
                      class: "order-mgmt-table"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "订单信息",
                          "min-width": "260"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(scope.row.order_id), 1),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(scope.row.goods_name), 1),
                              _createElementVNode("div", _hoisted_9, "￥" + _toDisplayString(scope.row.amount), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "quantity",
                          label: "数量",
                          width: "70"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "status",
                          label: "状态",
                          width: "90"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, {
                              type: statusTagType(scope.row.status),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.status_text || statusText(scope.row.status)), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "pay_mode",
                          label: "支付模式",
                          width: "100"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, {
                              size: "small",
                              effect: "plain"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.pay_mode === 'tenant' ? '自定义收款' : '系统收款'), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "授权信息",
                          "min-width": "220"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createElementVNode("span", null, _toDisplayString(scope.row.email || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("span", null, _toDisplayString(scope.row.auth_value || '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("span", null, _toDisplayString(scope.row.auth_result || '-'), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "created_at",
                          label: "下单时间",
                          width: "170"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          width: "220",
                          fixed: "right"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              size: "small",
                              onClick: ($event: any) => (openDetailDialog(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("详情")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (scope.row.status === 0)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  size: "small",
                                  type: "warning",
                                  onClick: ($event: any) => (openEditDialog(scope.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("修改")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (scope.row.status === 0 && scope.row.pay_mode === 'tenant')
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  size: "small",
                                  type: "success",
                                  onClick: ($event: any) => (markPaid(scope.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("标记已付")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, loading.value]
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_pagination, {
                        "current-page": currentPage.value,
                        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
                        "page-size": pageSize.value,
                        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
                        total: total.value,
                        "page-sizes": [10, 20, 50],
                        layout: "total, sizes, prev, pager, next",
                        onSizeChange: getOrderList,
                        onCurrentChange: getOrderList
                      }, null, 8, ["current-page", "page-size", "total"])
                    ])
                  ])
                ]),
                _createVNode(_component_el_dialog, {
                  modelValue: detailDialogVisible.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((detailDialogVisible).value = $event)),
                  title: "订单详情",
                  width: "600px"
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (detailDialogVisible.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("关闭")
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions, {
                      column: 1,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions_item, { label: "订单号" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.order_id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "商品名称" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.goods_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "订单金额" }, {
                          default: _withCtx(() => [
                            _createTextVNode("￥" + _toDisplayString(currentOrder.value.amount), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "购买数量" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.quantity), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "订单状态" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, {
                              type: statusTagType(currentOrder.value.status),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(currentOrder.value.status_text || statusText(currentOrder.value.status)), 1)
                              ]),
                              _: 1
                            }, 8, ["type"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "支付模式" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.pay_mode === 'tenant' ? '自定义收款' : '系统收款'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "支付渠道" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.pay_type), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "下单邮箱" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.email), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "授权字段" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.auth_value), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "授权结果" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.auth_result || '-'), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "查询密码" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.query_password), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "下单时间" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.created_at), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "支付时间" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(currentOrder.value.paid_at || '-'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_dialog, {
                  modelValue: editDialogVisible.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editDialogVisible).value = $event)),
                  title: "修改订单",
                  width: "500px"
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (editDialogVisible.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: submitEdit,
                      loading: submitting.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确认修改")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      model: editForm.value,
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "订单号" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              "model-value": editForm.value.order_id,
                              disabled: ""
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "授权字段" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: editForm.value.auth_value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.auth_value) = $event)),
                              placeholder: "请输入授权字段值"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "下单邮箱" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: editForm.value.email,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.email) = $event)),
                              placeholder: "请输入邮箱"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})